import { TranslationKey, translationKey } from 'intl/types/translationKey';

/**
 * AUTO-GENERATED — do not edit manually.
 * Run `yarn generate:translation-keys` after changing messages.en.json.
 */
export const ProjectSetupTranslationKeys = {
  addCompanySection: translationKey('add_company_section'),
  addContractSection: translationKey('add_contract_section'),
  addressCity: translationKey('address_city'),
  addressCountry: translationKey('address_country'),
  addressPostalCode: translationKey('address_postal_code'),
  addressStreetAndNumber: translationKey('address_street_and_number'),
  basicInfoSection: translationKey('company_basic_info_section'),
  correspondenceAddressFieldLabel: translationKey('company_correspondence_address_field_label'),
  involvementTypeFieldLabel: translationKey('company_involvement_type_field_label'),
  longLabelFieldLabel: translationKey('company_long_label_field_label'),
  registeredOfficeAddress: translationKey('company_registered_office_address'),
  sameAsRegisteredOfficeAddress: translationKey('company_same_as_registered_office_address'),
  shortLabelFieldLabel: translationKey('company_short_label_field_label'),
  tableShortLabel: translationKey('company_table_short_label'),
  taxNumberFieldLabel: translationKey('company_tax_number_field_label'),
  parties: translationKey('contract_parties'),
  createLevel: translationKey('create_level'),
  createOrganization: translationKey('create_organization'),
  createProject: translationKey('create_project'),
  createProjectDisabledReason: translationKey('create_project_disabled_reason'),
  createSite: translationKey('create_site'),
  deadlineAndBudget: translationKey('deadline_and_budget'),
  discardCompanyQuestionDialogTitle: translationKey('discard_company_question_dialog_title'),
  editCompanySection: translationKey('edit_company_section'),
  editContractSection: translationKey('edit_contract_section'),
  editLevel: translationKey('edit_level'),
  editOrganization: translationKey('edit_organization'),
  editProject: translationKey('edit_project'),
  editSite: translationKey('edit_site'),
  involvementTypeGeneralContractor: translationKey('involvement_type_general_contractor'),
  involvementTypeInvestor: translationKey('involvement_type_investor'),
  involvementTypeSubcontractor: translationKey('involvement_type_subcontractor'),
  languageAndLocation: translationKey('language_and_location'),
  archiveDisabledReasonLastItem: translationKey('level_archive_disabled_reason_last_item'),
  contactEmail: translationKey('organization_contactEmail'),
  label: translationKey('organization_label'),
  name: translationKey('organization_name'),
  budget: translationKey('project_budget'),
  currency: translationKey('project_currency'),
  endDate: translationKey('project_end_date'),
  language: translationKey('project_language'),
  loadingChooseAnotherProject: translationKey('project_loading_choose_another_project'),
  loadingChooseProject: translationKey('project_loading_choose_project'),
  loadingData: translationKey('project_loading_data'),
  loadingFailedDescription: translationKey('project_loading_failed_description'),
  loadingFailedOutdated: translationKey('project_loading_failed_outdated'),
  loadingFailedTitle: translationKey('project_loading_failed_title'),
  loadingNoAccessDescription: translationKey('project_loading_no_access_description'),
  loadingNoAccessTitle: translationKey('project_loading_no_access_title'),
  loadingRetry: translationKey('project_loading_retry'),
  name2: translationKey('project_name'),
  settingsNavigationFieldValues: translationKey('project_settings_navigation_field_values'),
  settingsNavigationFieldVisibility: translationKey('project_settings_navigation_field_visibility'),
  settingsNavigationGeneralProjectData: translationKey('project_settings_navigation_general_project_data'),
  settingsNavigationOrganizationData: translationKey('project_settings_navigation_organization_data'),
  settingsNavigationProjectStructure: translationKey('project_settings_navigation_project_structure'),
  settingsNavigationWorkflowConfiguration: translationKey('project_settings_navigation_workflow_configuration'),
  shortName: translationKey('project_short_name'),
  startDate: translationKey('project_start_date'),
  value: translationKey('project_value'),
  selectMap: translationKey('select_map'),
  selectOrganizationLabel: translationKey('select_organization_label'),
  deleteConflictInspectionsInProgress: translationKey('site_delete_conflict_inspections_in_progress'),
  previewCode: translationKey('site_preview_code'),
  previewLabel: translationKey('site_preview_label'),
  previewLevels: translationKey('site_preview_levels'),
  timezone: translationKey('timezone'),
  warningMapRemoval: translationKey('warning_map_removal'),
  warningMapReplacementGeneric: translationKey('warning_map_replacement_generic'),
  warningMapReplacementSpecific: translationKey('warning_map_replacement_specific'),
} as const satisfies Record<string, TranslationKey>;
